/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { Type } from '@uswitch/spark'

export { default as LinkListItem } from './link-list-item'

const LinkList = ({ title, children, ...rest }) => {
  return (
    <nav
      sx={{
        paddingTop: ['32px', '40px'],
        paddingBottom: ['16px', '24px'],
        paddingX: '16px',
        backgroundColor: 'grey-05',
      }}
      {...rest}
    >
      <Type.H4 as={'header'} sx={{ color: 'secondary', textAlign: 'center' }}>
        {title}
      </Type.H4>
      <ul
        sx={{
          listStyle: 'none',
          p: '0',
          m: '0',
          marginTop: '16px',
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        {children}
      </ul>
    </nav>
  )
}

export default LinkList
